import * as ACTIONS from "./../actions/actionConstants";

const initialState = {
  advancedSignUp: false,
  businessOptions: false,
  darkMode: false,
  deviceType: null,
  didInit: false
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.CHECK_DEVICE: {
      return {
        ...state,
        deviceType: action.payload
      };
    }

    case ACTIONS.TOGGLE_ADVANCED_SIGNUP: {
      return {
        ...state,
        advancedSignUp: action.payload
      };
    }

    case ACTIONS.TOGGLE_BUSINESS_OPTIONS: {
      return {
        ...state,
        businessOptions: action.payload
      };
    }

    case ACTIONS.TOGGLE_DARK_MODE: {
      return {
        ...state,
        darkMode: action.payload
      };
    }

    case ACTIONS.RESET_APP: {
      return {
        ...state,
        ...initialState
      };
    }

    case ACTIONS.DID_INIT: {
      return {
        ...state,
        didInit: action.payload
      };
    }

    default: {
      return state;
    }
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js